import { Logo } from '../assets/Logo';
import { AppStoreButton } from './AppStoreButton';
import { BrandWordmark } from './BrandWordmark';
import { PlayStoreButton } from './PlayStoreButton';

export function LandingHeader() {
  return (
    <header className="sticky top-0 z-50 shrink-0 border-b border-neutral-soft/80 bg-background-light/90 backdrop-blur-md max-md:fixed max-md:left-0 max-md:right-0 max-md:top-0">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-4 sm:px-6">
        <a
          href="/"
          className="flex items-center gap-2 sm:gap-3 min-w-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 rounded-lg"
          aria-label="I'd Go Back home"
        >
          <Logo className="size-9 sm:size-10 shrink-0" decorative />
          <BrandWordmark className="text-lg sm:text-xl truncate" />
        </a>
        <nav aria-label="Download" className="flex items-center gap-2 shrink-0">
          <AppStoreButton compact className="whitespace-nowrap" />
          <PlayStoreButton compact className="whitespace-nowrap" />
        </nav>
      </div>
    </header>
  );
}
